import styled from 'styled-components';

export * from './styled.shared';

export const CartItems = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  & > li {
    margin-top: 1rem;
  }

  & > li:first-of-type {
    margin-top: 0;
  }
`;
